import { RESOURCE } from "../../../../routes/const";
import ROLES from "../../../../const/Roles";

export default (account) => {
  const { roles } = account;
  const rules = [];
  if (
    Array.isArray(roles) &&
    roles
      .map((role) => role.toLowerCase())
      .includes(ROLES.FINANCE_UPDATE_ROLE.toLowerCase())
  ) {
    rules.push({
      action: "manage",
      subject: RESOURCE.finance.reloadData,
    });
  }
  return rules;
};
